module.exports = __webpack_public_path__ + "static/img/组 9(4).ddc611cf.png";